import React from "react";
import "./ContractStyle.css";

const ContractResponsibilities = () => {
  return (
    <div className="responsibilities">
      <h3>Responsibilities:</h3>
      <ul>
        <li>
          The renter is responsible for the bike, <strong>all costs resulting from
          any damages to the bike will be charged in full to the renter</strong>.
        </li>
        <li>
          The renter is responsible for the security and parking of the
          bike; a stolen or lost bike must be replaced in full at the same
          value as a new bike. <strong><u>Please only park in designated parking areas
          and do not leave the bike outside overnight!</u></strong>
        </li>
        <li>
          The loss of the helmet will be charged at <strong>250,000 VND</strong>, the loss of
          the phone holder will be charged at <strong>100,000 VND</strong>, the loss of the
          bicycle lights or lock/key at <strong>60,000 VND</strong>.
        </li>
        <li>
          The renter is responsible for contacting us if the bike has any
          problem before attempting to fix anything, any unauthorized
          repairs will not be covered by us. We provide motorbike & bicycle
          service in the <strong>Da Nang area ONLY!</strong> The customer is responsible
          outside of this area.
        </li>
        <li>
          The renter is responsible for fixing any flat tires, checking the
          air pressure before driving, and informing us of any problems at
          the end of the rental. <strong><u>All costs associated with a flat tire are
          the renter's sole responsibility.</u></strong>
        </li>
        <li>
          The renter is responsible for their driving license and insurance.
          Any police related issues are the renter's sole responsibility.
        </li>
        <li>
          The rental period is for <strong>24h</strong> from the start time, returns later
          than <strong>1h</strong> after that time will result in an extra day's charge.
        </li>
        <li><strong><u>NO returns outside opening hours!</u></strong></li>
      </ul>
    </div>
  );
};

export default ContractResponsibilities; 